// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { optimism as _optimism } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the optimism chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 10
 * Chain Name: OP Mainnet
 * Default Block Explorer: https://optimistic.etherscan.io
 * Default RPC URL: https://mainnet.optimism.io
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { optimism } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: optimism,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const optimism = createCommon({
	..._optimism,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
